import { gql } from '@apollo/client';

export const getAgendaUser = gql /* GraphQL */ `
query GetAgendaUser($userId: ID!) {
  getAgendaUser(userId: $userId) {
    comId
    image
    isConfirmed
    role
    suspended
    type
    timezone
    language
    userId
    username
    FCMtoken
    readedAt
    __typename
  }
}
`;

export const docsByUser = gql/* GraphQL */ `
query DocsByUser(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelAgendaDocumentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $userId: ID!
) {
  docsByUser(
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    userId: $userId
  ) {
    items {
      comId
      createdAt
      deleted
      docId
      name
      path
      type
      updatedAt
      userId
      user {
        username
        image
      }
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const createAgendaDocumentByUserId = gql/* GraphQL */ `
mutation CreateAgendaDocumentByUserId(
  $comId: ID
  $createdAt: AWSDateTime
  $deleted: Boolean
  $docId: ID!
  $name: String
  $path: String
  $type: String
  $updatedAt: AWSDateTime
  $userId: ID
) {
  createAgendaDocumentByUserId(
    comId: $comId
    createdAt: $createdAt
    deleted: $deleted
    docId: $docId
    name: $name
    path: $path
    type: $type
    updatedAt: $updatedAt
    userId: $userId
  ) {
    comId
    createdAt
    deleted
    docId
    name
    path
    type
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      tuesday
      type
      hours
      timezone
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    __typename
  }
}
`;

export const onCreateAgendaDocumentByUserId = gql/* GraphQL */ `
subscription OnCreateAgendaDocumentByUserId($userId: ID) {
  onCreateAgendaDocumentByUserId(userId: $userId) {
    comId
    createdAt
    deleted
    docId
    name
    path
    type
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      tuesday
      type
      hours
      timezone
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    __typename
  }
}
`;

export const updateAgendaDocument = gql/* GraphQL */ `
mutation UpdateAgendaDocument(
  $condition: ModelAgendaDocumentConditionInput
  $input: UpdateAgendaDocumentInput!
) {
  updateAgendaDocument(condition: $condition, input: $input) {
    comId
    createdAt
    deleted
    docId
    name
    path
    type
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      tuesday
      hours
      timezone
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    __typename
  }
}
`;

export const usersByComId = gql/* GraphQL */ `
query UsersByComId(
  $comId: ID!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelAgendaUserFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  usersByComId(
    comId: $comId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    nextToken
    __typename
  }
}
`;

export const docsByCom = gql/* GraphQL */ `
query DocsByCom(
  $comId: ID!
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelAgendaDocumentFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  docsByCom(
    comId: $comId
    createdAt: $createdAt
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      comId
      createdAt
      deleted
      docId
      name
      path
      type
      updatedAt
      userId
      __typename
      user {
        username
        image
      }
    }
    nextToken
    __typename
  }
}
`;